import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20.448 5.907a.534.534 0 00-.76.002L8.704 16.951l-4.396-4.396a.537.537 0 00-.913.386c0 .146.058.278.152.375l4.779 4.779.012.012.007.007.019.016.001.001a.535.535 0 00.68-.001l-.001.001.002-.002a.259.259 0 00.018-.016l.008-.008.011-.011.001-.001L20.448 6.669a.534.534 0 00-.002-.76z"
}), 'Agree');